import { Component, Input, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { MatSnackBar } from '@angular/material/snack-bar';
import { DialogComponent } from 'src/app/components/dialog/dialog.component';
import { User } from 'src/app/shared/interfaces/user.interface';
import { MembersService } from '../members.service';
import { environment } from 'src/environments/environment';
import { PermissionsService } from 'src/app/permissions/permissions.service';

@Component({
  selector: 'app-member-card',
  templateUrl: './member-card.component.html',
  styleUrls: ['./member-card.component.css'],
})
export class MemberCardComponent implements OnInit {
  @Input() member: User = null;
  @Input() actions: any[] = [];
  @Input() showActions: boolean = false;
  @Input() allowExpand: boolean = false;

  isExpanded: boolean = false;
  memberFunctions: any[] = [];
  isLoadingFunctions: boolean = false;

  constructor(
    private snackBar: MatSnackBar,
    private dialog: MatDialog,
    private memberService: MembersService,
    private permissionsService: PermissionsService
  ) {}

  ngOnInit(): void {}

  toggleExpand(): void {
    if (!this.allowExpand) return;
    this.isExpanded = !this.isExpanded;

    if (this.isExpanded && this.memberFunctions.length === 0) {
      this.isLoadingFunctions = true;
      this.permissionsService.getMemberFunctions(this.member?.id).then(res => {
        this.memberFunctions = res || [];
        this.isLoadingFunctions = false;
      }).catch(() => {
        this.isLoadingFunctions = false;
        this.snackBar.open('Erro ao buscar funções do membro.', null, { duration: 3000 });
      });
    }
  }

  delete(id: string, name: string): void {
    const dialogRef = this.dialog.open(DialogComponent, {
      width: '400px',
      height: '250px',
      data: {
        title: 'Excluir',
        text: ' Deseja remover o usuário ? ',
        name: name,
      },
    });

    dialogRef.afterClosed().subscribe((result) => {
      if (result) {
        this.memberService
          .deleteUser(id)
          .then((res: any) => {
            this.snackBar.open(res.message, null, {
              duration: 4000,
            });
            window.location.reload();
          })
          .catch((err: any) => {
            this.snackBar.open(err.error.message || 'Algo de errado aconteçeu');
          });
      }
    });
  }

  getAvatar(memberAvatar: any): any {
    if (!memberAvatar) {
      return environment.endPointApi + 'user/avatar/default-user.png';
    } else {
      return environment.endPointApi + 'user/avatar/' + memberAvatar.file_name;
    }
  }
}
